import * as O from 'fp-ts/Option'
import { pipe } from 'fp-ts/function'
import { addNameToUnitForm, listToMapName } from './FormSlave'
import type { FormWorker } from './FormWorker'
import { Unit } from './Unit'
import type { EmployeSubscriber } from './employees/EmployeSubscriber'
import type { FormStatus } from './formBuilder'

export const buildFormStatus = (
    name: FormWorker.Props['name'],
    valueFields: FormWorker.InternalValueFields,
    validatorFields: FormWorker.InternalValidatorFields
): FormStatus<string> => ({
    name: name,
    isValid:
        Object.values(valueFields)
            .filter(v => v.use === 'yep')
            .filter(v =>
                pipe(
                    O.fromNullable(validatorFields[v.name]),
                    O.filter(r => r.isValid === 'valid'),
                    O.isNone
                )
            ).length === 0,
})

export const buildInitialInternalValueFields = (
    unitsForm: FormWorker.Props['unitsForm'],
    employees: FormWorker.Props['employees']
): FormWorker.InternalValueFields =>
    addNameToUnitForm(unitsForm)
        .map(u => buildInitialFieldValue(u, employees))
        .reduce(listToMapName, {})

const buildInitialFieldValue = (
    unit: FormWorker.formUnitNamized,
    employees: FormWorker.Props['employees']
): FormWorker.InternalValueField => {
    return {
        name: unit.name,

        value: unit.value,
        data: unit.data,
        initialValue: unit.value,

        tags: unit.tags,

        observerEmployees: pipe(
            O.fromNullable(employees),
            O.map(e => e.config),
            O.map(e => Object.keys(e).filter(k => e[k].fieldsObserved.includes(unit.name))),
            O.map(Object.values),
            O.getOrElse((): string[] => [])
        ),

        use: 'unknown',
    }
}

const isInitAndValuePrefilled = (runType: EmployeSubscriber.runType, field: FormWorker.InternalValueField) =>
    runType === 'init' && typeof field.initialValue !== 'undefined'

export const buildInitialFieldValueFromUpdater = (
    runType: EmployeSubscriber.runType,
    field: FormWorker.InternalValueField,
    updateSubject: FormWorker.updateSubjects['fields']['field']
): FormWorker.InternalValueField => ({
    ...field,
    // se init non force cerco di popolare le label nel caso non ci siano
    // se force lo step dopo sovrascrive questo
    ...pipe(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        O.fromNullable(updateSubject.options),
        O.filter(_ => isInitAndValuePrefilled(runType, field)),
        O.match(
            () => ({}),
            os => ({
                data: Unit.initDataToDataOption('selectClassic', field.initialValue as string, { options: os }),
            })
        )
    ),
    ...pipe(
        O.fromNullable(updateSubject.current),
        // se init e ha un valore inizializzato non prosegue a meno che non sia esplicitato il force
        //
        // questo per prevenire eventuali sovrascritture degli employee fatte
        // durante inizilizzazione con form in modalita modifica quindi con un initialValue
        //
        // altrimenti ogni employe applicator deve controllare che in init non sovrascriva
        // un valore inserito dall'utente
        // con il valore che potrebbe arrivare dal server
        O.filter(c => c.forceOnInt === true || !isInitAndValuePrefilled(runType, field)),
        O.match(
            () => ({}),
            c => ({ ...c, initialValue: c.value })
        )
    ),
    ...pipe(
        O.fromNullable(updateSubject.disabled),
        O.match(
            () => ({}),
            d => ({ disabled: d })
        )
    ),
    ...pipe(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        O.fromNullable(updateSubject.options),
        O.match(
            () => ({}),
            o => ({ options: o })
        )
    ),
})
